import { useEffect, useState, useCallback } from 'react';

export default (function () {
  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var handler = useCallback(function (e) {
    if (e.key === 'Escape') {
      setOpen(false);
    }
  }, []);

  useEffect(function () {
    document.addEventListener('keydown', handler);
    return function () {
      document.removeEventListener('keydown', handler);
    };
  }, []);

  return { open: open, setOpen: setOpen };
});